import React, { useMemo } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

const StatsCard = ({ notificationsList = [] }) => {
    const stats = useMemo(() => {
        const total = notificationsList.length;
        const sent = notificationsList.filter(n => n.status === "Sent").length;
        const pending = notificationsList.filter(n => n.status === "Pending").length;
        const promo = notificationsList.filter(n => n.type === "Promotion" || n.type === "System").length;

        return [
            { title: "Total Notifications", value: total, icon: "bx-bell", color: "primary" },
            { title: "Sent Broadcasts", value: sent, icon: "bx-check-circle", color: "success" },
            { title: "Pending / Queued", value: pending, icon: "bx-time-five", color: "warning" },
            { title: "System & Promos", value: promo, icon: "bx-broadcast", color: "info" }
        ];
    }, [notificationsList]);

    return (
        <Row className="mb-4 gap-2">
            {stats.map((stat, index) => (
                <Col key={index} xl md="6">
                    <Card className="border-0 shadow-sm mb-0">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className={`avatar-sm bg-${stat.color}-subtle text-${stat.color} rounded-3 p-2 me-3 d-flex align-items-center justify-content-center`}>
                                    <i className={`bx ${stat.icon} fs-3`}></i>
                                </div>
                                <div>
                                    <h6 className="text-muted mb-1">{stat.title}</h6>
                                    <h4 className="mb-0 fw-bold">{stat.value}</h4>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default StatsCard;